<!-- Если не указаны высота или ширина -->
<img *ngIf="!height || !width"
     alt="logo"
     [style.max-height]="height ? height + 'px' : 'unset'"
     [style.max-width]="width ? width + 'px' : 'unset'"
     [src]="src"
     (error)="errorHandler($event)" />

<!-- Если указаны высота и ширина -->
<div *ngIf="height && width"
     class="d-flex align-items-center justify-content-between flex-wrap me-2"
     [style.height]="height + 'px'"
     [style.width]="width + 'px'">
  <img alt="logo"
       [src]="src"
       class="img-fluid mx-auto d-block"
       style="max-height: 100%"
       (error)="errorHandler($event)" />
</div>
